"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { Suspense, useEffect } from "react"
import Image from "next/image"
import Login from "../../components/common/authentication/Login"
import SnackbarMessage from "../../components/common/SnackbarMessage"
import blueLemon from "../../components/pages/signup/assets/images/blue-lemon.png"
import updateWarningMessage from "../../graphql/mutations/snackbarMessage/updateWarningMessage"

// import updateErrorMessage from "../../graphql/mutations/snackbarMessage/updateErrorMessage"
import { useApolloClient } from "@apollo/client/react"
import TopNavBar from "../../components/common/TopNavBar"

type LoginPageProps = {
  hasSessionExpired: boolean
}

export default function LoginPage({ hasSessionExpired }: LoginPageProps) {
  const apolloClient = useApolloClient()

  useEffect(() => {
    const handleSessionExpired = async () => {
      if (hasSessionExpired) {
        updateWarningMessage("Your session has expired. Please log in again.")
        try {
          await apolloClient.clearStore()
        } catch (error) {
          // updateErrorMessage("Sign-out failed: ", error?.message)
          // throw error
        }
      }
    }
    handleSessionExpired()
  }, [hasSessionExpired, apolloClient])
  const renderLogin = () => {
    return (
      <Suspense>
        <Login />
      </Suspense>
    )
  }

  const renderLeft = () => {
    return (
      <div className={`hidden min-[1100px]:flex w-1/2 relative `}>
        <Image
          src={blueLemon}
          fill={true}
          className={"object-cover object-center"}
          alt={"zest lemon image"}
          priority={true}
          sizes="(min-width: 1100px) 50vw"
        />
      </div>
    )
  }

  const renderRight = () => {
    return (
      <div className={`min-[1100px]:flex w-full min-[1100px]:w-1/2 flex-col`}>
        <div className={"relative w-full bg-white min-[1100px]:h-full"}>
          <div
            className={
              "pt-[20px] px-[10px] flex flex-col justify-center min-[1100px]:h-full items-center min-[1100px]:pt-0"
            }
          >
            {renderLogin()}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={"flex h-screen flex-col w-screen h-full"}>
      <TopNavBar startingBackgroundSolid={true} mobileSignUpButton={true} />
      <div className={"flex flex-row w-full h-full"}>
        {renderLeft()}
        {renderRight()}
      </div>
      <SnackbarMessage />
    </div>
  )
}
